var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_526_2163)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 0.15625C5.59375 0.15625 0 5.75 0 12.6562C0 18.1875 3.57812 22.8594 8.54687 24.5156C9.17187 24.625 9.4062 24.25 9.4062 23.9219C9.4062 23.625 9.39065 22.6406 9.39065 21.5938C6.25 22.1719 5.4375 20.8281 5.1875 20.125C5.04687 19.7656 4.4375 18.6562 3.90625 18.3594C3.46875 18.125 2.84375 17.5469 3.89063 17.5312C4.875 17.5156 5.57813 18.4375 5.8125 18.8125C6.9375 20.7031 8.73438 20.1719 9.45315 19.8438C9.5625 19.0312 9.89065 18.4844 10.25 18.1719C7.46875 17.8594 4.5625 16.7812 4.5625 12C4.5625 10.6406 5.04688 9.5156 5.84375 8.64062C5.71875 8.32812 5.28125 7.04687 5.96875 5.32812C5.96875 5.32812 7.01563 5 9.4062 6.60938C10.4062 6.32813 11.4688 6.1875 12.5313 6.1875C13.5938 6.1875 14.6563 6.32813 15.6563 6.60938C18.0469 4.98438 19.0938 5.32812 19.0938 5.32812C19.7813 7.04687 19.3438 8.32812 19.2188 8.64062C20.0156 9.5156 20.5 10.625 20.5 12C20.5 16.7969 17.5781 17.8594 14.7969 18.1719C15.25 18.5625 15.6406 19.3125 15.6406 20.4844C15.6406 22.1562 15.625 23.5 15.625 23.9219C15.625 24.25 15.8594 24.6406 16.4844 24.5156C21.4219 22.8594 25 18.1719 25 12.6562C25 5.75 19.4063 0.15625 12.5 0.15625Z",
    fill: "#C7C7C7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_526_2163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 0.15625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterGithub);
export default __webpack_public_path__ + "static/media/footerGithub.5e32481635d490a9a59ded7e459af50d.svg";
export { ForwardRef as ReactComponent };